const features = [
  {
    icon: 'ri-shield-check-line',
    title: 'Advanced Security',
    description: 'End-to-end encryption and real-time threat detection keep your data safe from hackers, trackers, and malicious networks.',
    bg: 'bg-violet-50',
    iconBg: 'bg-violet-100',
    iconColor: 'text-violet-600',
  },
  {
    icon: 'ri-speed-up-line',
    title: 'Peak Performance',
    description: 'Intelligent optimization algorithms remove clutter and free up memory, ensuring your iOS device runs at its absolute best.',
    bg: 'bg-amber-50',
    iconBg: 'bg-amber-100',
    iconColor: 'text-amber-600',
  },
  {
    icon: 'ri-eye-off-line',
    title: 'Complete Privacy',
    description: 'Your browsing activity, location, and personal data remain entirely private. No logs, no tracking, no compromises.',
    bg: 'bg-sky-50',
    iconBg: 'bg-sky-100',
    iconColor: 'text-sky-700',
  },
  {
    icon: 'ri-smartphone-line',
    title: 'Native iOS Design',
    description: 'Built exclusively for iOS with native components, smooth animations, and a design language that feels right at home on Apple devices.',
    bg: 'bg-orange-50',
    iconBg: 'bg-orange-100',
    iconColor: 'text-orange-600',
  },
  {
    icon: 'ri-global-line',
    title: 'Global Reach',
    description: 'Access content from anywhere in the world with our extensive server network spanning dozens of countries and regions.',
    bg: 'bg-teal-50',
    iconBg: 'bg-teal-100',
    iconColor: 'text-teal-600',
  },
  {
    icon: 'ri-customer-service-2-line',
    title: 'Dedicated Support',
    description: 'Our expert team is always available to assist you. Fast, friendly, and knowledgeable support whenever you need it.',
    bg: 'bg-rose-50',
    iconBg: 'bg-rose-100',
    iconColor: 'text-rose-600',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-28" style={{ background: 'rgb(248,248,248)' }}>
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="mb-16">
          <p className="text-xs uppercase tracking-[0.3em] text-gray-400 mb-4 font-medium">What We Offer</p>
          <h2 className="text-4xl md:text-5xl font-light text-gray-900 leading-tight max-w-2xl">
            Enhanced Security &amp;<br />
            <span className="font-semibold italic">Better Experience</span>
          </h2>
          <p className="mt-5 text-gray-500 text-base max-w-xl leading-relaxed">
            Every feature is thoughtfully engineered to give iOS users the protection, performance, and peace of mind they deserve.
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((f) => (
            <div
              key={f.title}
              className={`${f.bg} rounded-2xl p-7 flex flex-col gap-4 transition-transform duration-300 hover:-translate-y-1`}
            >
              <div className={`w-12 h-12 flex items-center justify-center rounded-xl ${f.iconBg}`}>
                <i className={`${f.icon} text-2xl ${f.iconColor}`} />
              </div>
              <div>
                <h3 className="text-base font-semibold text-gray-900 mb-2">{f.title}</h3>
                <p className="text-sm text-gray-500 leading-relaxed">{f.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
